import React, { Fragment, useContext } from 'react';

import style from "./checkout.modile.css";
import PaymentMethod from '../PaymentMethod/PaymentMethod.jsx';
import { PatientContext } from '../../Context/PatientContext.js';
import { CartContext } from '../../Context/CartContext.js';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';

export default function Checkout() {
   const { patient } = useContext(PatientContext);
   const { cart } = useContext(CartContext);


   return (
      <Fragment>
         <CustomTitle title="Check Out" />
         <div className='container'>
            <h1 className='main-header'>Check Out</h1>

            <div className="table" dir='rtl'>
               <table className='table table-sm text-center table-group-divider  table-responsive-md '>
                  <thead>
                     <th>الخدمة </th>
                     <th>العدد</th>
                     <th>السعر بالجنية</th>
                  </thead>

                  <tbody>
                     <tr>
                        <td>الخدمات  / الاشعة</td>
                        <td>{cart?.cartItems?.length}</td>
                        <td>{cart?.profilePrice || cart?.total_After_Discount}</td>
                     </tr>
                     <tr>
                        <td>زيارة منزلية</td>
                        <td>0</td>
                        <td>0</td>
                     </tr>
                  </tbody>

                  <tfoot>
                     <tr>
                        <th>الاجمالى </th>
                        <td></td>
                        <th>{cart?.profilePrice || cart?.total_After_Discount} جم</th>
                     </tr>
                  </tfoot>
               </table>
            </div>
            {cart.length === 0 ?
               <h3 className='text-center mt-3'>لا يوجد خدمات في السلة</h3>
               :
               <>
                  <div className='text-center'>
                     <button data-bs-toggle="modal" data-bs-target="#PaymentMethod" className="btn btn-sm bg-main text-white btn-lg mt-2">اختار طريقة الدفع</button>
                  </div>
                  <PaymentMethod userData={patient} />
               </>
            }
         </div>
      </Fragment>
   )
}
